import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/bungee/400.css";
import "@fontsource/lilita-one/400.css";
import "@fontsource/shrikhand/400.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./styles/globals.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
